import React from "react";
import BottomNav from "./BottomNav";
import CartDrawer from "./CartDrawer";
import { Toaster } from "../components/ui/sonner";

const AppShell = ({ children }) => {
    return (
        <div
            data-testid="app-shell"
            className="relative mx-auto w-full min-h-[100dvh] bg-[#0A0A0A] text-white max-w-[480px] overflow-hidden"
        >
            {children}
            <BottomNav />
            <CartDrawer />
            <Toaster
                theme="dark"
                position="top-center"
                toastOptions={{
                    style: {
                        background: "#141414",
                        border: "1px solid #262626",
                        color: "#fff",
                    },
                }}
            />
        </div>
    );
};

export default AppShell;
